import Chip from "@material-ui/core/Chip"
import { makeStyles } from "@material-ui/core/styles"
import { useWorkflowRequirementTranslations } from "./use-translations"

type WorkflowRequirementChipProps = {
  required: boolean
}

const WorkflowRequirementChip = ({ required }: WorkflowRequirementChipProps) => {
  const classes = useStyles()
  const translations = useWorkflowRequirementTranslations()
  const label = required ? translations.requiredStepLabel : translations.optionalStepLabel

  return (
    <Chip
      size="small"
      label={label}
      color={required ? "primary" : "default"}
      variant={required ? "default" : "outlined"}
      className={classes.requirementChip}
    />
  )
}

const useStyles = makeStyles((theme) => ({
  requirementChip: {
    borderRadius: 2,
    height: 15,
    width: "fit-content",
    fontWeight: 600,
    letterSpacing: 0.5,
    fontSize: 10,

    "& .MuiChip-label": {
      paddingLeft: theme.spacing(0.75),
      paddingRight: theme.spacing(0.75),
    },

    "&.MuiChip-colorPrimary": {
      backgroundColor: theme.palette.info.main,
    },
  },
}))

export default WorkflowRequirementChip
